import { useEffect, useState } from 'react';

export const useLastUndefinedValue = <T>(currentValue: T): T | undefined => {
  const [value, setValue] = useState(currentValue);
  useEffect(() => {
    if (currentValue) {
      setValue(currentValue);
    }
  }, [currentValue]);
  return value;
};
